// extracted by mini-css-extract-plugin
module.exports = {"theme":"#00b1c3"};